"use client";

import { Asset, AssetFields, ChainModifiers } from "contentful";
import { ContentImage } from "@/components/molecules/ContentImage/ContentImage";
import css from "./Gallery.module.css";
import { cn } from "@boostdev/design-system-components/utils";
import Link from "next/link";
import { useTranslation } from "react-i18next";

interface GalleryProps {
  media: Asset<ChainModifiers, string>[] | undefined;
}

export function Gallery({ media }: GalleryProps) {
  const { t } = useTranslation(undefined);
  return (
    <section className={cn([css.gallery])}>
      <div className={cn([css.galleryContent])}>
        {media?.map((image) => {
          return (
            <figure key={image.sys.id} className={css.figure}>
              <ContentImage
                className={cn([css.image])}
                fields={image.fields as AssetFields}
                width={500}
              />
              {image?.fields.title && (
                <figcaption>{image.fields.title as string}</figcaption>
              )}
            </figure>
          );
        })}
        <Link href={"/gallery"}>{t("common:allPhotos")}</Link>
      </div>
    </section>
  );
}
